import { render, staticRenderFns } from "./InvestmentBalancePanel.vue?vue&type=template&id=cb1c060c&scoped=true"
import script from "./InvestmentBalancePanel.vue?vue&type=script&lang=ts"
export * from "./InvestmentBalancePanel.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentBalancePanel.vue?vue&type=style&index=0&id=cb1c060c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1c060c",
  null
  
)

export default component.exports